import React, {useState, useEffect, useCallback, useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import {ProgressSpinner} from 'primereact/progressspinner';
import {InputNumber} from 'primereact/inputnumber';
import {
    getActasAdmin,
    getCivilSates,
    getColaboratorById, getColaboratorsList, getPuestoColaborador, getPuestos, getScholarTypes,
    updateColaborador, updatePuesto
} from './integracion';
import {Checkbox} from 'primereact/checkbox';
import {Calendar} from 'primereact/calendar';
import {isoAFechaLocal} from '../../../utilidades/formateos';
import './TestForm.scss';
import {getTypeActas, postNuevaActa} from "../FormularioAltas/integracion";
import {InputTextarea} from "primereact/inputtextarea";
import Swal from "sweetalert2";
import {Card} from "primereact/card";
import {TabPanel, TabView} from "primereact/tabview";
import TablaActasAdmin from "../FormularioAltas/TablaActasAdmin";

function toYYYYMMDD(date) {
    if (!(date instanceof Date)) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`; // sin hora
}

function toYYYYMMDD_HHMMSS_00(date) {
    const d = toYYYYMMDD(date);
    return d ? `${d} 00:00:00` : null;
}

const FormColaborador = (usuarioId, onCloseDialog) => {


    const [form, setForm] = useState({
        ID: null,
        ACTIVO: null,
        NOMBRE: "",
        ESTATUS: null,
        DIRECCION: "",
        CODIGO: null,
        COLONIA: "",
        REFERENCIA: "",
        ESTADO: "",
        MUNICIPIO: "",
        CELULAR: "",
        TELEFONO: "",
        CELULAR_PARTICULAR: "",
        TEL_ESPOSA: "",
        INGRESO: null,
        FECHA_BAJA: null,
        FECHA_NACIMIENTO: null,
        RFC: "",
        CURP: "",
        AFILIACION: "",
        TALLA_CAMISA: "",
        TALLA_PANTALON: "",
        ESTADO_CIVIL: null,
        SEXO: null,
        ID_ESCOLARIDAD: null,
        EMAIL: "",
        LONGITUD: null,
        LATITUD: null,
        USUARIO: null,
        CONSUME_DROGAS: null,
        ALTURA: null,
        PESO: null,
        FUMA: null,
        CONSUME_ALCOHOL: null,
        TIPO_SANGRE: null,
        INTERVERCIONES_QUIRURJICAS: false,
        TIPO_INTERVERCIONES_QUIRURJICA: null,
        FRECUENCIA_CARDIACA: null,
        IMC: null,
        TIPO_SANGRE_EMERGENCIA: null,
        GLICEMIA_CAPILAR: null,
        ENTREGA_LICENCIA: null,
        APTO_MEDICO: null,
        ID_NIVEL_HIGIENE: null,
        DIA_DESCANSO: null,
        ID_PUESTO: "",
        ID_PUESTO_GIRO: null,
        NUMERO_LICENCIA: null,
        VENCIMIENTO_LICENCIA: null,
        FOTOGRAFIA: 'https://via.placeholder.com/150',
        RAW_IMAGE: null
    });

    const [escolaridadOptions, setEscolaridadOptions] = useState([]);
    const [estadoCivilOptions, setEstadoCivilOptions] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [actasOptions, setActasOptions] = useState([]);
    const [colaboradorPuesto, setColaboradorPuesto] = useState([]);
    const [leaderOptions, setLeaderOptions] = useState([]);
    const [puestos, setPuestos] = useState([]);
    const [actasAdmin, setActasAdmin] = useState([]);
    const [userImage, setUserImage] = useState('https://via.placeholder.com/150');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const typeOptions = [
        {label: 'DIRECTO', value: 1},
        {label: 'STAFF', value: 2},
        {label: 'PROVEEDOR', value: 3}
    ];


    async function fetchActas(userId) {

        const actasAdmin = await getActasAdmin(userId);
        setActasAdmin(actasAdmin);

        await fetchTypeActas();
    }

    useEffect(() => {
        const fetchOptions = async () => {
            try {

                const escolaridadData = await getScholarTypes();
                const formattedEscolaridad = escolaridadData.map(item => ({
                    label: item.ESCOLARIDAD,
                    value: item.ID,
                }));

                setEscolaridadOptions(formattedEscolaridad);

                const leadersList = await getColaboratorsList()
                setLeaderOptions(leadersList);

                const puestos = await getPuestos();
                setPuestos(puestos);

                const estadoCivilData = await getCivilSates();
                const formattedEstadoCivil = estadoCivilData.map(item => ({
                    label: item.NOMBRE,
                    value: item.ID,
                }));
                setEstadoCivilOptions(formattedEstadoCivil);


                const puestoColab = await getPuestoColaborador(usuarioId.usuarioId);
                setColaboradorPuesto(puestoColab);

            } catch (error) {

            }
        };

        fetchOptions();
    }, [usuarioId.usuarioId]);

    useEffect(() => {
        // Verificamos que exista el usuario antes de llamar (opcional pero recomendado)
        if (form.USUARIO) {
            fetchActas(form.USUARIO);
        }
    }, [form.USUARIO]);
    const sexoOptions = [
        {label: 'MASCULINO', value: 1},
        {label: 'FEMENINO', value: 2},
        {label: 'N/A', value: 0}
    ];
    const loadUserData = useCallback(async () => {
        if (!usuarioId) {
            resetForm();
            setIsEditing(true); // Se inicia en modo de edición para poder llenar los campos
            setLoading(false);

            return;
        }

        setLoading(true);
        setError(null);

        try {
            const data = await getColaboratorById(usuarioId.usuarioId);

            if (data) {

                const formData = {
                    ID: data.ID || null,
                    ACTIVO: data.ACTIVO,
                    NOMBRE: data.NOMBRE ? data.NOMBRE.trim() : "",
                    DIRECCION: data.DIRECCION ? data.DIRECCION.trim() : "",
                    CP: data.CP ? data.CP.trim() : null,
                    COLONIA: data.COLONIA ? data.COLONIA.trim() : "",
                    CONTACTO_EMERGENCIA: data.CONTACTO_EMERGENCIA ? data.CONTACTO_EMERGENCIA.trim() : "",
                    CONTACTO_TELEFONO: data.CONTACTO_TELEFONO ? data.CONTACTO_TELEFONO.trim() : "",
                    TELEFONO_CASA: data.TELEFONO_CASA ? data.TELEFONO_CASA.trim() : "",
                    TELEFONO_CELULAR: data.TELEFONO_CELULAR ? data.TELEFONO_CELULAR.trim() : "",
                    FECHA_INGRESO: data.FECHA_INGRESO ? isoAFechaLocal(data.FECHA_INGRESO) : null,
                    FECHA_BAJA: data.FECHA_BAJA ? isoAFechaLocal(data.FECHA_BAJA) : null,
                    FECHA_NACIMIENTO: data.FECHA_NACIMIENTO ? isoAFechaLocal(data.FECHA_NACIMIENTO) : null,
                    RFC: data.RFC ? data.RFC.trim() : "",
                    CURP: data.CURP ? data.CURP.trim() : "",
                    ID_ESTADO_CIVIL: data.ID_ESTADO_CIVIL ? parseInt(data.ID_ESTADO_CIVIL, 10) : null,
                    ID_GENERO: data.ID_GENERO ? parseInt(data.ID_GENERO, 10) : null,
                    ID_ESCOLARIDAD: data.ID_ESCOLARIDAD ? parseInt(data.ID_ESCOLARIDAD, 10) : null,
                    USUARIO: data.USUARIO || null,
                    ID_COLABORADOR_JEFE: data.ID_COLABORADOR_JEFE || null,
                    ID_RHFLEX: data.ID_RHFLEX || null,
                    IMSS: data.IMSS || null,
                    CONYUGUE_FECHA_NACIMIENTO: data.CONYUGUE_FECHA_NACIMIENTO ? isoAFechaLocal(data.CONYUGUE_FECHA_NACIMIENTO) : null,
                    CONYUGUE_NOMBRE: data.CONYUGUE_NOMBRE || "",
                    CONYUGUE_TELEFONO: data.CONYUGUE_TELEFONO ? data.CONYUGUE_TELEFONO.trim() : "",
                    CONSUME_DROGAS: data.CONSUME_DROGAS || null,
                    ALTURA: data.ALTURA || null,
                    PESO: data.PESO || null,
                    FUMA: data.FUMA || null,
                    MOTIVO_BAJA: data.MOTIVO_BAJA || null,
                    TIPO_CONSUMO_DROGAS: data.TIPO_CONSUMO_DROGAS || null,
                    CONSUME_ALCOHOL: data.CONSUME_ALCOHOL || null,
                    TIPO_SANGRE: data.TIPO_SANGRE || null,
                    INTERVERCIONES_QUIRURJICAS: data.INTERVERCIONES_QUIRURJICAS || false,
                    TIPO_INTERVERCIONES_QUIRURJICA: data.TIPO_INTERVERCIONES_QUIRURJICA || null,
                    FRECUENCIA_CARDIACA: data.FRECUENCIA_CARDIACA || null,
                    IMC: data.IMC || null,
                    NOMBRE_JEFE: data.NOMBRE_JEFE || "",
                    TIPO: data.TIPO || null,
                    GLICEMIA_CAPILAR: data.GLICEMIA_CAPILAR || null,
                    ID_PUESTO: data.ID_PUESTO || null,
                    ID_PUESTO_GIRO: data.ID_PUESTO_GIRO ? parseInt(data.ID_PUESTO_GIRO, 10) : null,
                    FOTOGRAFIA: data.FOTOGRAFIA || 'https://via.placeholder.com/150',
                };

                setForm(formData);
                const puestoColab = await getPuestoColaborador(usuarioId.usuarioId);
                setColaboradorPuesto(puestoColab);
                if (data.FOTOGRAFIA) {
                    setUserImage(`${process.env.REACT_APP_EMPLOYEES_IMAGE_URL}/${data.FOTOGRAFIA.trim()}`);
                }
            } else {
                setError("No se encontraron datos para el ID proporcionado.");
                resetForm();
            }
        } catch (err) {
            setError("Error al cargar los datos. Por favor, intente de nuevo.");
        } finally {
            setLoading(false);
        }
    }, [usuarioId]);

    const puestoLabel = useMemo(() => {
        if (!colaboradorPuesto || !Array.isArray(puestos) || puestos.length === 0) return '';

        const id = Number(colaboradorPuesto);
        const found = puestos.find(p => Number(p.value) === id);
        return found?.label || '';
    }, [colaboradorPuesto, puestos]);


    useEffect(() => {
        if (usuarioId) {

            loadUserData();

            setIsEditing(false);
        } else {

            resetForm();
            setIsEditing(true);
            setLoading(false);
        }
    }, [loadUserData, usuarioId]);

    const resetForm = () => {
        setForm({
            ID: null,
            ACTIVO: null,
            NOMBRE: "",
            ESTATUS: null,
            DIRECCION: "",
            CODIGO: null,
            COLONIA: "",
            REFERENCIA: "",
            ESTADO: "",
            MUNICIPIO: "",
            CELULAR: "",
            TELEFONO: "",
            CELULAR_PARTICULAR: "",
            TEL_ESPOSA: "",
            INGRESO: null,
            FECHA_NACIMIENTO: null,
            RFC: "",
            CURP: "",
            AFILIACION: "",
            TALLA_CAMISA: "",
            TALLA_PANTALON: "",
            ESTADO_CIVIL: null,
            SEXO: null,
            ID_ESCOLARIDAD: null,
            EMAIL: "",
            LONGITUD: null,
            LATITUD: null,
            USUARIO: "",
            DIA_DESCANSO: null,
            ID_PUESTO: "",
            ID_PUESTO_GIRO: null,
            FOTOGRAFIA: 'https://via.placeholder.com/150',
            CONSUME_DROGAS: false, // O null si prefieres
            ALTURA: null,
            PESO: null,
            FUMA: false,
            CONSUME_ALCOHOL: false,
            APTO_MEDICO: false,
            ENTREGA_LICENCIA: null,
            FECHA_BAJA: null,
            IMC: null,
            FRECUENCIA_CARDIACA: null,
            GLICEMIA_CAPILAR: null,
            INTERVERCIONES_QUIRURJICAS: null,
            NUMERO_LICENCIA: null,
            ID_NIVEL_HIGIENE: null,
            VENCIMIENTO_LICENCIA: null,
            TIPO_SANGRE: "",
            TIPO_SANGRE_EMERGENCIA: "",
            TIPO_INTERVERCIONES_QUIRURJICA: ""
        });
        setUserImage('https://via.placeholder.com/150');
    };

    useEffect(() => {
        loadUserData();
    }, [loadUserData]);


    const handleFieldChange = (fieldName, value) => {
        setForm(prevForm => {
            const newForm = {...prevForm, [fieldName]: value};
            return newForm;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const forceStringFields = new Set(['AFILIACION', 'TALLA_CAMISA', 'ID_RHFLEX']);

        const formDataWithCorrectTypes = {};
        for (const key in form) {
            if (!Object.prototype.hasOwnProperty.call(form, key)) continue;
            const value = form[key];

            if (typeof value === 'boolean') {
                formDataWithCorrectTypes[key] = value ? 1 : 0;
            } else if (value instanceof Date) {
                formDataWithCorrectTypes[key] = toYYYYMMDD_HHMMSS_00(value); // o toYYYYMMDD_HHMMSS_00
            } else if (forceStringFields.has(key)) {

                const str = value === null || value === undefined ? '' : String(value).trim();
                formDataWithCorrectTypes[key] = str;
            } else if (typeof value === 'string' && !isNaN(Number(value)) && value.trim() !== '') {

                formDataWithCorrectTypes[key] = Number(value);
            } else if (value !== null && value !== undefined) {
                formDataWithCorrectTypes[key] = value;
            } else {
                formDataWithCorrectTypes[key] = null;
            }
        }

        const data = {
            puesto: puestoLabel,
            id_puesto: colaboradorPuesto,
            id_colaborador: form.ID,
            usuario: form.USUARIO,
        };


        const hasUsuario = data.usuario !== undefined && data.usuario !== null && String(data.usuario).trim() !== "";
        const hasPuestoLabel = puestoLabel !== undefined && puestoLabel !== null && String(puestoLabel).trim() !== "";
        const hasIdPuesto = data.id_puesto !== undefined && data.id_puesto !== null && String(data.id_puesto).trim() !== "";

        if (!hasUsuario && !hasPuestoLabel) {

        } else if (!hasUsuario && hasIdPuesto) {
            await Swal.fire({
                icon: "warning",
                title: "No se pudo actualizar el puesto",
                text: "Falta un usuario para realizar la actualización del puesto.",
                confirmButtonText: "Entendido"
            });

            setColaboradorPuesto(null)

        } else if (hasUsuario && hasIdPuesto) {
            updatePuesto(data);
        }

        delete formDataWithCorrectTypes.FOTOGRAFIA;

        if (form.RAW_IMAGE instanceof File) {
            const params = new FormData();
            for (const key in formDataWithCorrectTypes) {
                if (!Object.prototype.hasOwnProperty.call(formDataWithCorrectTypes, key) || key === 'RAW_IMAGE') continue;
                const v = formDataWithCorrectTypes[key];
                if (v === null) {

                    params.append(`${key}__isNull`, '1');
                } else {
                    params.append(key, v);
                }
            }
            params.append('FOTOGRAFIA', form.RAW_IMAGE);
            await updateColaborador(params);
        } else {
            const { RAW_IMAGE, ...dataToSend } = formDataWithCorrectTypes;
            await updateColaborador(dataToSend);
        }

        setIsEditing(false);
    };


    const handleClear = () => {
        resetForm();
        setIsEditing(false);
    };

    const handleChangeImage = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setUserImage(reader.result);
                    setForm(prevForm => ({
                        ...prevForm,
                        RAW_IMAGE: file
                    }));
                };
                reader.readAsDataURL(file);

            }
        };
        fileInput.click();
    };

    const fetchTypeActas = async () => {
        try {
            const tipoActas = await getTypeActas()
            setActasOptions(tipoActas);

        } catch (e) {
            console.error('Error fetching actas:', e);
        }
    }
    const handleSaveActa = async (payload) => {

        try {
            const acta = {
                ID: payload.ID ?? undefined,
                NOMBRE: payload.NOMBRE,
                NUM_ACTA: payload.NUM_ACTA,
                ID_ACTA: payload.ID_ACTA,
                MOTIVO: payload.MOTIVO,
                ID_USUARIO: form.USUARIO || 0,
                FECHA_ACTA: payload.FECHA_ACTA,
            };

            const ok = await postNuevaActa(acta);

            if (ok) {
                await Swal.fire({
                    icon: "success",
                    title: "Acta guardada",
                    text: "El acta se registró correctamente.",
                    timer: 1800,
                    showConfirmButton: false
                });
                await fetchActas();
            } else {
                await Swal.fire({
                    icon: "error",
                    title: "No se pudo guardar",
                    text: "El servidor no confirmó el guardado.",
                });
            }
        } catch (e) {
            await Swal.fire({
                icon: "error",
                title: "Error al guardar",
                text: e?.response?.data?.message || "Ocurrió un error inesperado.",
            });
            console.error("Error guardando acta:", e);
        }
    };
    const renderField = (fieldName, labelText, type = 'text', options = []) => {
        const isNonEditable = ['ID', 'EMAIL', 'NOMBRE_JEFE', "EMAIL"].includes(fieldName);
        const fieldValue = form[fieldName];


        let displayValue = fieldValue;
        if (type === 'date' && fieldValue instanceof Date) {
            displayValue = fieldValue.toLocaleDateString('es-MX');
        } else if (type === 'dropdown' && fieldValue !== null && fieldValue !== undefined) {
            const option = options.find(opt => opt.value === fieldValue);
            displayValue = option ? option.label : String(fieldValue);
        } else if (type === 'cb') {
            displayValue = fieldValue ? (

                <i className='pi pi-check-circle' style={{fontSize: '1rem', color: '#007202ff'}}></i>

            ) : (

                <i className='pi pi-times-circle' style={{fontSize: '1rem', color: '#ff0505ff'}}></i>

            )


        } else if (fieldValue === null || fieldValue === undefined) {
            displayValue = '';
        } else {
            displayValue = String(fieldValue).trim();
        }


        if (isNonEditable || !isEditing) {
            return (
                <div className="data-row-th" key={fieldName}>
                    <label className="field-name-th">{labelText} </label>
                    <label style={{maxWidth: '350px'}}>{displayValue}</label>
                </div>
            );
        }


        switch (type) {
            case 'date':

                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>

                        <Calendar value={fieldValue} onChange={(e) => {
                            handleFieldChange(fieldName, e.value)
                        }}> </Calendar>


                    </div>
                );

            case 'dropdown':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <Dropdown
                            value={fieldValue}
                            options={options}
                            filter
                            onChange={(e) => handleFieldChange(fieldName, e.value)}
                            placeholder={`Seleccionar ${labelText}`}
                            className="p-inputtext-sm"
                            style={{fontSize: '12px'}}
                        />
                    </div>
                );

            case 'number':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <InputNumber
                            value={fieldValue}
                            onValueChange={(e) => handleFieldChange(fieldName, e.value)}
                            mode="decimal"
                            useGrouping={false}
                            className="p-inputtext-sm"
                            style={{fontSize: '12px'}}
                        />
                    </div>
                );

            case 'short-number':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText}</label>
                        <InputNumber
                            value={fieldValue}
                            onValueChange={(e) => handleFieldChange(fieldName, e.value)}
                            mode="decimal"
                            useGrouping={false}

                            className="p-inputtext-sm"

                        />
                    </div>
                );
            case 'cb':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <Checkbox
                            checked={fieldValue || false}
                            onChange={(e) => handleFieldChange(fieldName, e.checked)}
                            className="p-checkbox-sm"/>

                    </div>
                );
            case 'long-text':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <InputTextarea
                            value={fieldValue || ''}
                            onChange={(e) => handleFieldChange(fieldName, e.target.value)}
                            autoResize
                            rows={3}
                            className='my-large-input p-inputtext-sm'
                        />
                    </div>
                );
            case 'text':
            default:
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <InputText
                            value={fieldValue || ''}
                            onChange={(e) => handleFieldChange(fieldName, e.target.value)}

                            className='my-large-input p-inputtext-sm'
                        />
                    </div>
                );
        }
    };

    if (loading) {
        return (
            <div className="flex justify-content-center align-items-center" style={{height: '300px'}}>
                <ProgressSpinner/>
                <p>Cargando datos del usuario...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-message p-message-error" style={{margin: '20px'}}>
                <div className="p-message-text">{error}</div>
                <p>Por favor, asegúrate de que el ID sea válido o intenta de nuevo.</p>
            </div>
        );
    }

    const isInactive = Number(form.ACTIVO) === 0;

    const edad = form.FECHA_NACIMIENTO ? calcularEdad(form.FECHA_NACIMIENTO) : null;

    return (
        <div className="table-personal-th">
            <div className="user-profile-layout-final">
                <div className="profile-header">
                    <img src={userImage} alt="Foto de perfil" className="header-image"/>
                    {isEditing && (
                        <Button
                            label=""
                            icon="pi pi-upload"
                            className="change-image-button"
                            style={{marginRight: '10px'}}
                            onClick={handleChangeImage}
                        />
                    )}
                    <div className="header-info">
                        <h2 className="header-name">{form.NOMBRE || 'Colaborador'}</h2>
                        <div className="header-meta">
                            <span><strong>ID:</strong> {form.ID || 'N/A'}</span>
                            <span><b>Usuario:</b> {renderField('USUARIO', '', 'short-number')}</span>
                        </div>
                    </div>
                    <div className="header-actions">

                        {!isEditing && (
                            <Button
                                label="Editar"
                                icon="pi pi-pencil"
                                style={{marginRight: '10px', backgroundColor: '#ff6400', borderColor: '#ff6400'}}
                                onClick={() => setIsEditing(true)}
                            />
                        )}
                        {isEditing && (
                            <div className="editing-actions">
                                <Button label="Guardar" icon="pi pi-save" className="p-button-success"
                                        onClick={(e) => handleSubmit(e)}/>
                                {usuarioId && (
                                    <Button
                                        label="Cancelar"
                                        icon="pi pi-times"
                                        style={{
                                            marginRight: '10px',
                                            marginLeft: '10px',
                                            backgroundColor: '#ff1010',
                                            borderColor: '#9e0000'
                                        }}
                                        onClick={() => {
                                            setIsEditing(false);
                                            loadUserData();
                                        }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className="tabs-container">
                    <TabView>
                        <TabPanel header="Información">
                            <div className="info-cards-container">
                                <Card
                                    title={<div className="card-title-container"><i className="pi pi-user mr-2"/><span>Datos Personales y de Contacto</span>
                                    </div>}>
                                    <div className="form-grid">
                                        {renderField('NOMBRE', 'Nombre Completo')}
                                        {renderField('FECHA_NACIMIENTO', 'F. Nacimiento', 'date')}
                                        {/* Edad solo lectura */}
                                        <div className="data-row-th">
                                            <label className="field-name-th">Edad</label>
                                            <label style={{maxWidth: '350px'}}>{edad ?? ''}</label>
                                        </div>
                                        {renderField('RFC', 'RFC')}
                                        {renderField('CURP', 'CURP')}
                                        {renderField('ID_GENERO', 'Sexo', 'dropdown', sexoOptions)}
                                        {renderField('DIRECCION', 'Dirección')}
                                        {renderField('COLONIA', 'Colonia')}
                                        {renderField('CP', 'C.P.', 'number')}
                                        {renderField('TELEFONO_CASA', 'Teléfono Casa')}
                                        {renderField('TELEFONO_CELULAR', 'Teléfono SUMA')}
                                        {renderField('CONTACTO_EMERGENCIA', 'Contacto Emergencia')}
                                        {renderField('CONTACTO_TELEFONO', 'Tel. Emergencia')}
                                    </div>
                                </Card>

                                <Card title={<div className="card-title-container"><i className="pi pi-briefcase mr-2"/><span>Información Laboral</span>
                                </div>}>
                                    <div className="form-grid">
                                        {renderField('ACTIVO', 'Activo', 'cb')}
                                        {renderField('FECHA_INGRESO', 'Fecha Ingreso', 'date')}
                                        {isInactive && renderField('FECHA_BAJA', 'Fecha Baja', 'date')}
                                        {renderField('ID_PUESTO', 'Puesto', 'dropdown', puestos)}
                                        {renderField('ID_COLABORADOR_JEFE', 'Líder Inmediato', 'dropdown', leaderOptions)}
                                        {renderField('ID_ESCOLARIDAD', 'Escolaridad', 'dropdown', escolaridadOptions)}
                                        {renderField('TIPO', 'Tipo', 'dropdown', typeOptions)}
                                        {renderField('IMSS', 'IMSS', 'number')}
                                        {renderField('ID_RHFLEX', 'ID RHFLEX')}
                                        {isInactive && renderField('MOTIVO_BAJA', 'Motivo Baja', 'long-text')}
                                    </div>
                                </Card>

                                <Card title={<div className="card-title-container"><i
                                    className="pi pi-heart-fill mr-2"/><span>Salud y Emergencia</span></div>}>
                                    <div className="form-grid">
                                        {renderField('ALTURA', 'Altura (m)', 'number')}
                                        {renderField('PESO', 'Peso (kg)', 'number')}
                                        {renderField('IMC', 'IMC', 'number')}
                                        {renderField('TIPO_SANGRE', 'Tipo Sangre')}
                                        {renderField('FRECUENCIA_CARDIACA', 'Frecuencia Cardiaca', 'number')}
                                        {renderField('GLICEMIA_CAPILAR', 'Glicemia Capilar', 'number')}
                                        {renderField('FUMA', 'Fuma', 'cb')}
                                        {renderField('CONSUME_ALCOHOL', 'Consume Alcohol', 'cb')}
                                        {renderField('CONSUME_DROGAS', 'Consume Drogas', 'cb')}
                                        {renderField('TIPO_CONSUMO_DROGAS', 'Tipo de Drogas')}
                                        {renderField('INTERVERCIONES_QUIRURJICAS', 'Intervenciones Quirúrgicas', 'cb')}
                                        {renderField('TIPO_INTERVERCIONES_QUIRURJICA', 'Tipo de Intervenciones')}
                                        {renderField('CONYUGUE_NOMBRE', 'Nombre Cónyuge')}
                                        {renderField('CONYUGUE_FECHA_NACIMIENTO', 'F. Nac. Cónyuge', 'date')}
                                        {renderField('CONYUGUE_TELEFONO', 'Tel. Cónyuge')}
                                    </div>
                                </Card>

                                <Card title={<div className="card-title-container"><i
                                    className="pi pi-sitemap mr-2"/><span>Puesto</span></div>}>
                                    <div className="form-grid">
                                        {isEditing ? (
                                            <div className="data-row-th" style={{gridColumn: '1 / -1'}}>
                                                <label className="field-name-th">Puesto</label>
                                                <Dropdown
                                                    value={colaboradorPuesto ?? null}
                                                    options={puestos}
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    onChange={(e) => setColaboradorPuesto(e.value)}
                                                    placeholder="Selecciona un puesto"
                                                    filter
                                                    showClear
                                                    virtualScrollerOptions={{itemSize: 36}}
                                                    className="p-inputtext-sm"
                                                />
                                            </div>
                                        ) : (
                                            <div className="data-row-th" style={{gridColumn: '1 / -1'}}>
                                                <label className="field-name-th">Puesto</label>
                                                <label style={{maxWidth: '350px'}}>{puestoLabel || 'Sin puesto'}</label>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            </div>
                        </TabPanel>
                        <TabPanel header="Actas Administrativas">
                            <TablaActasAdmin data={actasAdmin} onSave={handleSaveActa} options={actasOptions}
                                             chofer={form} fetchActas={fetchActas}/>
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </div>
    );
};

function calcularEdad(fechaNacimiento) {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);

    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const diferenciaMes = hoy.getMonth() - nacimiento.getMonth();

    if (diferenciaMes < 0 || (diferenciaMes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--;
    }

    return edad;
}

export default FormColaborador;